import "devextreme/dist/css/dx.light.css";
import { RequiredRule, EmailRule, CustomRule } from "devextreme-react/form";
import DataGrid, {
  Export,
  Button,
  Column,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  Editing,
  Popup,
  Lookup, //for dropdown
  Form,
  ToolbarItem,
} from "devextreme-react/data-grid";
import "devextreme-react/text-area";
import { Item } from "devextreme-react/form";
import { onExporting } from "../../../../../utils";
import { useCallback, useEffect, useState } from "react";
import {
  actionEmployerList,
  resetEmployerList,
  actionEmployerAdd,
  resetEmployerAdd,
  actionZoneList,
  resetZoneList,
  actionEmpStatus,
  resetEmpStatus
} from "../store";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import EmployerAddEdit from "../../../../../component/popups/employer_add_edit";
import Loader from '../../../../../component/page_loader';
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION } from "../../../../../common/app_constant";
import { useNavigate } from "react-router-dom";

const EmployerList = () => {
  const navigate = useNavigate();
  const [employerDetails, setEmployerDetails] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [zoneDropdown, setZoneDropdown] = useState([]);
  const [zoneIds, setZoneIds] = useState([

  ]);
  const [employerData, setEmployerData] = useState(null);
  const [isLoader, setIsLoader] = useState(true);
  const dispatch = useDispatch();
  const { EmployerList, ZoneList, EmployerAdd, EmpStatus } = useSelector(
    (state) => ({
      ...state.listStore,
    })
  );

  useEffect(() => {
    dispatch(actionEmployerList());
    dispatch(actionZoneList());
  }, []);

  useEffect(() => {
    if (EmployerList) {
      dispatch(resetEmployerList());
      if (EmployerList.status === true) {
        setIsLoader(false);
        setEmployerDetails(EmployerList.data);
      }
    }
  }, [EmployerList]);

  useEffect(() => {
    if (ZoneList) {
      dispatch(resetZoneList());
      if (ZoneList.status) {
        setZoneDropdown(ZoneList.data);
      }
    }
  }, [ZoneList]);

  useEffect(() => {
    if (EmployerAdd) {
      dispatch(resetEmployerAdd());
      if (EmployerAdd.status) {
        toast.success("Employee added successfully");
      }
    }
  }, [EmployerAdd]);

  useEffect(() => {
    if (EmpStatus) {
      dispatch(resetEmployerList());
      if (EmpStatus.status === true) {
        dispatch(actionEmployerList());
      } else {
        switch (EmpStatus.status_code) {
          case 400:
            dispatch(resetEmployerList());
            toast.error(EmpStatus.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [EmpStatus]);

  const rendercapitalizeData = (value) => {
    return value ? value.charAt(0).toUpperCase() + value.slice(1) : "-";
  };

  const renderDateCell = (date) => {
    return moment(date).isValid() ? moment(date).format("DD-MMM-YYYY") : "-";
  };

  const renderZoneCell =(value)=>{
    return value.map(zone => zone.name).join(', ')
  }

  const renderEmpStatus = data => (
    <button
    className={`btn btn-sm btn-${data.status === 'ACTIVE' ? "success" : "danger"
  } cursor-pointer ${data.status != 'ACTIVE' ? "disabled" : ""} w-100`}
      onClick={() =>
        Swal.fire({
          title: "",
          icon: "warning",
          text: `Are you sure you want to ${data.status === 'ACTIVE'? "Inactive" : "Active"
            }  '${data.full_name}'?`,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-danger ms-1 margin-left",
          },
        }).then(
          result =>
            result.value &&
            // dispatch(actionEmpStatus({ id: data?.id, status: !data.status }))
            dispatch(actionEmpStatus({ id: data?.id, status: data.status === 'ACTIVE'? "INACTIVE" : "ACTIVE" }))
        )
      }
    >
      {data.status === 'ACTIVE' ? "Active" : "Inactive"}
    </button>
  );

  const renderAction = (data) => (
    <button
      className={`btn btn-sm btn-primary cursor-pointer w-80`}
      onClick={() => {
        setIsModalOpen(true);
        setEmployerData(data);
        const zoneIds = data.employerZones.reduce((tempArray, zones) => {
          tempArray.push(zones.id);
          return tempArray
        }, [])
        setZoneIds(zoneIds)
      }}
    >
      Edit
    </button>
  );

  const renderZones = (zones) => {
    const temp = zones?.reduce((totalArr, zone) => {
      totalArr?.push(zone.name);
      return totalArr;
    }, []);
    return temp?.join(", ");
  };

  return (
    <div className="row  justify-content-center mb-5 mt-6">
      <div className="col-12 mb-5">
        <div className="d-flex justify-content-between mb-2">
          <div><h5 className="mb-0">Employer List</h5></div>
          <div>
            <button
              className={`btn btn-sm btn-primary cursor-pointer `}
              onClick={() => {
                setIsModalOpen(true);
                setEmployerData(null);
              }}
            >
              Add
            </button>
          </div>
        </div>
        {isLoader === true ? (
          <Loader />
        ) : (
          <div className="card border mt-3 d-flex">
            <div className="card-body" id="data-grid-demo">
              <DataGrid
                id="emp_list"
                dataSource={employerDetails}
                showBorders={true}
                columnMinWidth={100}
                filterSyncEnabled={false}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onExporting={onExporting}
              >
                <SearchPanel visible={true} />
                <FilterRow visible={true} />
                <HeaderFilter visible={true} />
                <Column
                  width={50}
                  dataField="action"
                  cellRender={({ data }) => renderAction(data)}
                  caption="Action"
                ></Column>
                <Column
                  dataField="index"
                  caption="S.No"
                  dataType="number"
                  cellRender={(rowData) => {
                    return rowData?.rowIndex != null
                      ? Number(rowData?.rowIndex + 1)
                      : "-";
                  }}
                />
                <Column
                  dataField="full_name"
                  caption="Full Name "
                  cellRender={({ value }) => rendercapitalizeData(value)}
                />
                <Column
                  dataField="mobile"
                  caption="Mobile Number"
                  dataType="string"
                />
                <Column dataField="email" caption="Email ID " />
                {/* <Column
                dataField="city.name"
                caption="City "
                cellRender={({ value }) => rendercapitalizeData(value)}
              /> */}
                <Column
                  dataField="employerZones"
                  caption="Zone"
                  cellRender={({ value }) => renderZoneCell(value)}
                />
                <Column
                  dataField="created_at"
                  caption="Created at"
                  dataType="date"
                  cellRender={({ value }) => renderDateCell(value)}
                />
                <Column
                  width={50}
                  dataField="status"
                  renderEmpStatus
                  cellRender={({ data }) => renderEmpStatus(data)}
                  caption="Status"
                ></Column>
                <Pager
                  visible={true}
                  showPageSizeSelector={false}
                  showNavigationButtons={true}
                  allowedPageSizes={[4, 6, 10]}
                />
                <Paging
                  defaultPageIndex={0}
                  defaultPageSize={10}
                  enabled={true}
                />
                <Export enabled={true} />
              </DataGrid>
            </div>
          </div>
        )}
      </div>
      <EmployerAddEdit
        show={isModalOpen}
        employerData={employerData}
        zoneIds={zoneIds}
        handleClose={() => {
          setIsModalOpen(false);
          dispatch(actionEmployerList());
        }}
      />
    </div>
  );
};

export default EmployerList;
